import {emailService} from '../services'

const state = {
    all: {
        loading: false,
        total: 0,
        rows: []
    },
    loading: false
}

const actions = {

    sendTest({ dispatch, commit }, params) {
        commit('startRequest')
        emailService.sendTest(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'A test email has been sent to ' + response.email, { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to send email: ' + error, { root: true })
            }
        )
    },
}

const mutations = {
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
}

const getters = {
    isBusy () {
        return state.loading === true
    }
}

export const emailModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
